// extracted by mini-css-extract-plugin
export default {"header":"CardTransparent_header__HUg1a"};